export default "__VITE_PUBLIC_ASSET__2248461e__"